import React from 'react';
import { AnnotationOverlay } from '../../AnnotationOverlay';
import { AnnotationRect } from '../types';

interface AnnotationLayerProps {
  annotations: AnnotationRect[];
  selectedAnnotationId: string | null;
  setSelectedAnnotationId: (id: string | null) => void;
  annotationStyle: 'fill' | 'outline';
  isAnnotationMode: boolean;
  currentAnnotation?: AnnotationRect | null;
  isDrawing?: boolean;
  onDeleteAnnotation: (id: string) => void;
  clearOtherSelection?: () => void;
}

export const AnnotationLayer: React.FC<AnnotationLayerProps> = ({
  annotations,
  selectedAnnotationId,
  setSelectedAnnotationId,
  annotationStyle,
  isAnnotationMode,
  currentAnnotation,
  isDrawing,
  onDeleteAnnotation,
  clearOtherSelection
}) => {
  return (
    <AnnotationOverlay
      annotations={annotations}
      selectedAnnotationId={selectedAnnotationId}
      setSelectedAnnotationId={setSelectedAnnotationId}
      clearOtherSelection={clearOtherSelection}
      annotationStyle={annotationStyle}
      isAnnotationMode={isAnnotationMode}
      currentAnnotation={currentAnnotation}
      isDrawing={isDrawing}
      onDeleteAnnotation={onDeleteAnnotation}
    />
  );
};